module.exports = __webpack_public_path__ + "static/media/sale.bb804d3c.webp";